import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Trusted Partner in Solar Energy Solutions",
    description: [
        "Welcome to Sunspot, your reliable source for professional solar energy services. We are committed to delivering efficient, sustainable, and innovative solar solutions that power your future.",
    ],
    points: [
        "Custom Solar Panel Installation",
        "Expert System Maintenance",
        "High-Quality Solar Components",
        "Sustainable Energy Solutions",
    ],
    image: {
        src: images.about,
        alt: "Solar Energy About Image",
    },
    button: {
        text: "Get a Quote",
        link: "Get-Quote"
    }
};

export default About;